import { render, staticRenderFns } from "./Dynamic.vue?vue&type=template&id=a2f1a6fe&scoped=true&"
import script from "./Dynamic.vue?vue&type=script&lang=ts&"
export * from "./Dynamic.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2f1a6fe",
  null
  
)

export default component.exports